import React from "react";
import Gate from "../../Gate";

const Screen30 = () => {
    return <Gate />;
};

export default Screen30;
